/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

interface NewsImageProps {
  image: string;
  style?: {};
  testId?: string;
}

const NewsImage = ({ image, style, testId }: NewsImageProps) => {
  return (
    <img
      data-testid={testId || "news-image"}
      src={`/img/news/${image}`}
      alt={`${image}`}
      css={css([
        {
          width: "100%",
          borderRadius: "8px"
        },
        style
      ])}
    />
  );
};

export default NewsImage;
